import * as React from "react";
import type { SVGProps } from "react";
const SvgIconBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.24 1.6q-.11.04-.22.1c-.06.03-1.48 1.15-3.16 2.5C1.7 6.73 1.71 6.72 1.63 6.96c-.04.12-.06 14.5-.02 14.74.06.36.32.62.68.69.2.04 19.22.04 19.42 0 .36-.07.62-.33.68-.7.02-.1.03-1.64.02-5.42V11l-.07-.13q-.14-.3-.42-.44l-.16-.07-3.26-.01h-3.26V8.71c0-1.8 0-1.77-.15-1.99-.06-.08-.89-.75-3.12-2.54l-3.1-2.47c-.16-.1-.44-.15-.63-.11m-2.38 4L3.31 7.62V20.7h4.25v-1.27l.01-1.26.07-.14c.07-.17.25-.34.41-.43.18-.08.48-.1.67-.02s.42.3.5.48c.04.14.04.17.04 1.4v1.24h4.28V7.64L10.99 5.6 8.43 3.56c-.01 0-1.17.91-2.57 2.03m-.1 3.2c-.22.07-.44.28-.53.5-.07.19-.07.44 0 .62s.25.37.43.46l.14.07h5.23l.13-.06c.17-.08.35-.26.43-.43.05-.11.06-.17.06-.35s0-.24-.06-.35c-.08-.16-.26-.35-.43-.43l-.13-.06H8.45c-2.07 0-2.6 0-2.68.02m9.48 7.58v4.3h5.45v-8.6h-5.45zm-9.47-2.81c-.59.19-.79.94-.37 1.4q.12.12.26.2l.14.06h5.23l.13-.06c.17-.08.35-.27.43-.43.05-.11.06-.17.06-.35s0-.24-.06-.35c-.08-.17-.26-.35-.43-.43l-.13-.06H8.45c-2.03-.01-2.6 0-2.68.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconBuilding;
